import { ref } from 'vue'
import { getInventorySettings } from '@/api/settings'

// 库位功能开关（每租户独立，后端 system_settings 'inventory.locationEnabled'，缺省关闭）。
// 各表单/列表用 useLocationEnabled() 拿到的 ref 做 v-if 显隐库位字段；
// 设置页保存成功后调用 setLocationEnabled 立即生效，无需刷新页面。
const locationEnabled = ref(false)
let loaded = false
let loading: Promise<void> | null = null

export function useLocationEnabled() {
  if (!loaded && !loading) {
    loading = getInventorySettings()
      .then((res: any) => {
        locationEnabled.value = res?.data?.data?.locationEnabled === '1'
        loaded = true
      })
      .catch(() => { loaded = true })
      .finally(() => { loading = null })
  }
  return locationEnabled
}

export function setLocationEnabled(v: boolean) {
  locationEnabled.value = v
  loaded = true
}
